/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EmployeeDocumentListResponse = {
    type: 'array',
    contains: {
        type: 'EmployeeDocumentResponse',
    },
};